
import { defineComponent } from 'vue';
import Default from './components/Default.vue'
import Error404 from './components/Error404.vue'
export default defineComponent({
  name: 'PageIndex',
  components: {
    Default,
    Error404,
  },
});
